app.factory('visitModel', ['$rootScope', '$q', 'baseModel', 'visitService',
    function($rootScope, $q, baseModel, visitService) {

	    function VisitModel() {

			function visitSavingErrors(error) {
				if(error.status === 400) {
					if(error.data.errors && error.data.errors[0].message === 'Date must be in future') {
						$rootScope.$broadcast(Event.ERROR, new ErrorVO('T.SYSTEM.ERROR.ERROR', 'T.SYSTEM.ERROR.VISIT_DATE_MUST_BE_IN_FUTURE'));
					}
				} else {
					baseModel.broadcastOperationFailed();
				}
			}
	
		   	this.getDataPage = function(criteria) {
                return visitService.getDataPage(criteria).then(
		   			function (dataPage) {
		   				$rootScope.$broadcast(Event.VISIT.GET_DATA_PAGE.SUCCESS, dataPage, criteria.pageNumber);
						return dataPage;
		   			},
		   			function(error) {
		   				$rootScope.$broadcast(Event.VISIT.GET_DATA_PAGE.ERROR, error);
						return $q.reject(error);
		   			}
		   		)
		    };
		    
		    this.getById = function(id) {
                return visitService.getById(id).then(
			   		function (visit) {
			   			$rootScope.$broadcast(Event.VISIT.GET_BY_ID.SUCCESS, visit);
                        return visit;
			   		},
			   		function(error) {
			   			$rootScope.$broadcast(Event.VISIT.GET_BY_ID.ERROR, error);
                        return $q.reject(error);
                    }
			   	)
		    };

			this.begin = function(id) {
                return visitService.begin(id).then(
					function (visit) {
						$rootScope.$broadcast(Event.VISIT.BEGIN.SUCCESS, visit);
                        return visit;
					},
					function(error) {
						$rootScope.$broadcast(Event.VISIT.BEGIN.ERROR, error);
                        return $q.reject(error);
                    }
				)
			};

			this.save = function(visit) {
                return visitService.save(visit).then(
					function (newVisit) {
						$rootScope.$broadcast(Event.VISIT.SAVE.SUCCESS, newVisit);
                        return newVisit;
					},
					function(error) {
						$rootScope.$broadcast(Event.VISIT.SAVE.ERROR, error);
                        // fixme it should be done by ErrorInterceptor
						visitSavingErrors(error);
                        return $q.reject(error);
                    }
				)
			};

			this.update = function(visit) {
                return visitService.update(visit).then(
					function (updatedVisit) {
						$rootScope.$broadcast(Event.VISIT.UPDATE.SUCCESS, updatedVisit);
                        return updatedVisit;
					},
					function(error) {
						$rootScope.$broadcast(Event.VISIT.UPDATE.ERROR, error);
                        // fixme it should be done by ErrorInterceptor
						visitSavingErrors(error);
                        return $q.reject(error);
                    }
				)
			};

			this.delete = function(visit) {
                return visitService.delete(visit).then(
					function (updatedVisit) {
						$rootScope.$broadcast(Event.VISIT.DELETE.SUCCESS, updatedVisit);
                        return updatedVisit;
					},
					function(error) {
						$rootScope.$broadcast(Event.VISIT.DELETE.ERROR, error);
                        return $q.reject(error);
                    }
				)
			};

			this.cancel = function(visit, cancellationType) {
                return visitService.cancel(visit, cancellationType).then(
					function (updatedVisit) {
						$rootScope.$broadcast(Event.VISIT.CANCEL.SUCCESS, updatedVisit);
                        return updatedVisit;
					},
					function(error) {
						$rootScope.$broadcast(Event.VISIT.CANCEL.ERROR, error);
                        return $q.reject(error);
                    }
				)
			};

			this.getStreamingConnectionDetails = function(streamingSessionId) {
                return visitService.getStreamingConnectionDetails(streamingSessionId).then(
					function (updatedVisit) {
						$rootScope.$broadcast(Event.VISIT.STREAMING_CONNECTION_DETAILS.SUCCESS, updatedVisit);
                        return updatedVisit;
					},
					function(error) {
						$rootScope.$broadcast(Event.VISIT.STREAMING_CONNECTION_DETAILS.ERROR, error);
                        return $q.reject(error);
                    }
				)
			};

			this.getLastVisitForPatient = function(patientId, doctorId) {
                return visitService.getLastVisitForPatient(patientId, doctorId).then(
					function (visit) {
						$rootScope.$broadcast(Event.VISIT.GET_LAST_VISIT_FOR_PATIENT.SUCCESS, visit);
                        return visit;
					},
					function(error) {
						$rootScope.$broadcast(Event.VISIT.GET_LAST_VISIT_FOR_PATIENT.ERROR, error);
                        return $q.reject(error);
                    }
				)
			};

			this.suspend = function(visit) {
                return visitService.suspend(visit).then(
					function (suspendedVisit) {
						$rootScope.$broadcast(Event.VISIT.SUSPEND.SUCCESS, suspendedVisit);
                        return suspendedVisit;
					},
					function(error) {
						$rootScope.$broadcast(Event.VISIT.SUSPEND.ERROR, error);
                        return $q.reject(error);
                    }
				)
			};

			this.complete = function(visit) {
                return visitService.complete(visit).then(
					function (closedVisit) {
						$rootScope.$broadcast(Event.VISIT.COMPLETE.SUCCESS, closedVisit);
                        return closedVisit;
					},
					function(error) {
						$rootScope.$broadcast(Event.VISIT.COMPLETE.ERROR, error);
                        return $q.reject(error);
					}
				)
			};

			this.checkForVisitsToFill = function(criteria) {
				return visitService.getDataPage(criteria).then(
					function (dataPage) {
						$rootScope.$broadcast(Event.VISIT.CHECK_FOR_VISITS_TO_FILL.SUCCESS, dataPage, criteria.pageNumber);
                        return dataPage;
					},
					function(error) {
						$rootScope.$broadcast(Event.VISIT.CHECK_FOR_VISITS_TO_FILL.ERROR, error);
                        return $q.reject(error);
                    }
				)
			};

			this.getZM = function(visitId) {
				return visitService.getZM(visitId).then(
					function (zm) {
						$rootScope.$broadcast(Event.VISIT.GET_ZM.SUCCESS, zm);
						return zm;
					},
					function(error) {
						$rootScope.$broadcast(Event.VISIT.GET_ZM.ERROR, error);
						return $q.reject(error);
					}
				);
			};

			this.sendZM = function(visitId) {
				return visitService.sendZM(visitId).then(
					function (successResponse) {
						$rootScope.$broadcast(Event.VISIT.SEND_ZM.SUCCESS, successResponse);
						return successResponse;
					},
					function(error) {
						$rootScope.$broadcast(Event.VISIT.SEND_ZM.ERROR, error);
						$rootScope.$broadcast(Event.VALIDATION_ERROR, new ErrorVO('T.SYSTEM.ERROR.ERROR', error.data.errorMessage));
						return $q.reject(error);
					}
				);
			};
	
	    }
	
	    return new VisitModel();
	}
]);
